var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokIconYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12C1 5.925 5.925 1 12 1h16c6.075 0 11 4.925 11 11v16c0 6.075-4.925 11-11 11H12C5.925 39 1 34.075 1 28V12z",
    stroke: "#F9B035",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.394 24.969c1.558 0 2.82-1.115 2.82-2.82V9.5h3.382c-.19 2.307 2.104 4.535 4.633 4.484v3.18c-2.163 0-4.002-.914-4.642-1.422v6.407c0 2.82-2.219 6.018-6.193 6.018-3.974 0-6.144-3.198-6.144-6.018 0-3.98 4.212-6.29 7.002-5.725v3.24a2.965 2.965 0 00-.81-.124c-1.571-.057-2.868 1.216-2.868 2.609a2.82 2.82 0 002.82 2.82z",
    fill: "#F9B035"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIconYellow);
export default __webpack_public_path__ + "static/media/tiktok-icon-yellow.ce937b0fa910cd07c6e9fa7aed46a176.svg";
export { ForwardRef as ReactComponent };